require('./contractLoanDueInformation.scss');
require('./contractLoanDueInformation.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { OKMessage } = require('commonsComponents/OKMessage');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
// @constants
const { DEFAULT_TRANSLATION_TEXT } = require('constants/index');
const {
    retailLoanDoTaggin: { TAGGING_GDPR_RIGHTS_DATA_PROTECTION },
} = require('../../../loansConstants/index');
//@helpers
const { buildEventsWizardRetailLoan } = require('../../../loansUtilities/loansHelper');
//@utilities
const {
    recordLinkV2,
} = require('utilities/tagging');

class ContractLoanDueInformation extends React.Component {

    constructor(props) {
        super(props);

        this.handleClickComplementaryText = this.handleClickComplementaryText.bind(this);
    }

    handleClickComplementaryText() {
        const { immRetailLoan } = this.props;
        const customData = buildEventsWizardRetailLoan(immRetailLoan, TAGGING_GDPR_RIGHTS_DATA_PROTECTION);
        recordLinkV2(customData);
    }

    buildDueInformationTitle(title) {
        const content = formatText(title);
        return content !== DEFAULT_TRANSLATION_TEXT ? (
            <span className="contract-loan-due-information__title">
                {content}
            </span>
        ) : null;
    }

    buildComplementaryText(complementaryText) {
        return (
            <span onClick={this.handleClickComplementaryText}>
                <FormattedText value={complementaryText} />
            </span>
        );
    }

    render() {
        const { title, message, complementaryText } = this.props;
        const titleContent = this.buildDueInformationTitle(title);
        const complementaryTextComponent = complementaryText ? this.buildComplementaryText(complementaryText) : null;

        return (
            <div className="contract-loan-due-information">
                <OKMessage type="informative">
                    {titleContent}
                    <span className="contract-loan-due-information__message">
                        <FormattedText value={message} />
                        {complementaryTextComponent}
                    </span>
                </OKMessage>
            </div>
        );
    }
}

ContractLoanDueInformation.propTypes = {
    complementaryText: PropTypes.string,
    immRetailLoan: PropTypes.object.isRequired,
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = ContractLoanDueInformation;
